/* eslint-disable no-useless-catch */
import { useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { toast } from "ToastAlertContainer";

const patchCompanyAdminGroupUser = async ({
  companyId,
  adminGroupId,
  adminGroupUserId,
  adminGroupUser,
}) => {
  let pathAndHost = window.location.protocol + window.location.host;

  let url = new URL(
    `/api/v2/companies/${companyId}/admin_groups/${adminGroupId}/admins/${adminGroupUserId}`,
    pathAndHost
  );

  let updatedAdminGroupUser;
  try {
    updatedAdminGroupUser = await axios.patch(url, adminGroupUser);
  } catch (err) {
    console.error(err.response.data);
    throw err;
  }

  return updatedAdminGroupUser;
};

export default function usePatchCompanyAdminGroupUser() {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ companyId, adminGroupId, adminGroupUserId, adminGroupUser }) =>
      await patchCompanyAdminGroupUser({
        companyId,
        adminGroupId,
        adminGroupUserId,
        adminGroupUser,
      }),
    {
      onMutate: async ({
        companyId,
        adminGroupId,
        adminGroupUserId,
        adminGroupUser,
      }) => {
        await queryClient.cancelQueries(["companies", companyId, "admins"]);

        const previousAdminGroupUsers = queryClient.getQueryData([
          "companies",
          companyId,
          "admins",
        ]);

        // console.log("previousAdminGroupUsers :>> ", previousAdminGroupUsers);
        // console.log("adminGroupUser :>> ", adminGroupUser);

        let optimisticAdminGroupUsers = previousAdminGroupUsers.map((agu) => {
          if (agu.admin_group_user_id === adminGroupUser.admin_group_user_id) {
            // console.log("adminGroupUser in map :>> ", adminGroupUser);
            agu = adminGroupUser;
          }
          return agu;
        });

        // console.log(
        //   "optimisticAdminGroupUsers :>> ",
        //   optimisticAdminGroupUsers
        // );

        queryClient.setQueryData(
          ["companies", companyId, "admins"],
          optimisticAdminGroupUsers
        );

        return {
          previousAdminGroupUsers,
          optimisticAdminGroupUsers,
          companyId,
        };
      },
      onError: (err, adminGroupUser, context) => {
        toast.error("Oops, there was an issue updating that admin user");
        queryClient.setQueryData(
          ["companies", context.companyId, "admins"],
          context.previousAdminGroupUsers
        );
      },
      onSettled: ({ companyId }) => {
        queryClient.invalidateQueries(["companies", companyId, "admins"]);
      },
    }
  );
}
